<template>
  <SettingEditLayout
    title="会社情報"
    summary="会社名、連絡先として使用する情報です。"
    :fields="fields"
    :validate="validate"
  >
    <template #default="{ form }">
      <div class="setting-fields">
        <label for="company-name">会社名<span class="required">必須</span></label>
        <CInput
          id="company-name"
          v-model.trim="form.company_name"
          maxlength="100"
          description="請求書や各種通知の差出人情報として使用されます。"
        />

        <label for="company-email">会社メールアドレス</label>
        <CInput
          id="company-email"
          v-model.trim="form.company_email"
          type="email"
          maxlength="254"
          description="空のままでも保存できます。"
        />

        <label for="company-tel">電話番号</label>
        <CInput
          id="company-tel"
          v-model.trim="form.telephone"
          maxlength="16"
          description="16文字まで。空のままでも保存できます。"
        />
      </div>
    </template>
  </SettingEditLayout>
</template>

<script>
import SettingEditLayout from '../SettingEditLayout.vue'
import { findSection } from '../settingSections'

/**
 * 会社情報だけを直す画面。
 *
 * <p>前は、電話番号を1つ直すのにも 1,974行の画面を開いて、
 * 全項目の中から探すことになっていた。</p>
 */
export default {
  name: 'CompanyInfoEdit',
  components: { SettingEditLayout },

  data () {
    return { fields: findSection('company').fields }
  },

  methods: {
    /**
     * 断る理由は、<b>押す前に分かる形</b>で書く。
     * サーバも同じところを見ているが、往復を待たせない。
     */
    validate (form) {
      if (!form.company_name) return '会社名を入力してください。'
      if (form.company_name.length > 100) {
        return '会社名は100文字以内で入力してください。'
      }
      if (form.company_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.company_email)) {
        return '会社メールアドレスを正しく入力してください。'
      }
      if (form.telephone && form.telephone.length > 16) {
        return '電話番号は16文字以内で入力してください。'
      }
      return ''
    }
  }
}
</script>

<style scoped>
.setting-fields {
  display: grid;
  gap: 0.25rem;
  max-width: 34rem;
}

.setting-fields label {
  margin-top: 0.75rem;
  font-weight: 600;
}

.required {
  margin-left: 0.4rem;
  padding: 0.1rem 0.4rem;
  border-radius: 0.2rem;
  background: #e55353;
  color: #fff;
  font-size: .75rem;
  font-weight: 600;
}
</style>
